import { smb_fetch, getSsoCgiUrl } from '@/api/operator/fetch';
import cookie from '@/utils/cookie';

let activeSummaryResult = null;
export const getActiveSummary = (data) => {
  if (activeSummaryResult) {
    return activeSummaryResult;
  }
  const url = getSsoCgiUrl('poe_service/v1/account_red_line', 'get_ad_customer_list');
  const agency_uid = cookie.get('agency_uid');
  return activeSummaryResult = smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    headers: {
      'x-platform-type': 2, // 1：工作台  2.服务商
      'x-account-id': agency_uid,
    },
    data,
  }, false, false);
};

let warningSummaryResult = null
export const getWarningSummary = (data) => {
  if (warningSummaryResult) {
    return warningSummaryResult;
  }
  const url = getSsoCgiUrl('poe_service/v1/account_warning', 'get_ad_customer_list');
  const agency_uid = cookie.get('agency_uid');
  return warningSummaryResult = smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    headers: {
      'x-platform-type': 2, // 1：工作台  2.服务商
      'x-account-id': agency_uid,
    },
    data,
  }, false, false);
};

